import type { TemplateInfo } from '@knapsack/types';

export function getTemplateInfoText(templateInfo: TemplateInfo): string {
  switch (templateInfo.rendererId) {
    case 'angular':
    case 'react': {
      const { exportName } = templateInfo;
      return exportName;
    }
    case 'html': {
      const { codeSrcPath } = templateInfo;
      return codeSrcPath;
    }
    case 'vue': {
      const { codeSrcPath } = templateInfo;
      return codeSrcPath;
    }
    case 'web-components': {
      const { elementName } = templateInfo;
      return elementName;
    }
    case 'twig': {
      const { namespacePath } = templateInfo;
      return namespacePath;
    }
    case 'hbs': {
      const { codeSrcPath } = templateInfo;
      return codeSrcPath;
    }
    default: {
      const _: never = templateInfo;
      return '';
    }
  }
}
